import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const CleanTextAreaWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;

  textarea.clean-text-area {
    border: ${theme.borders.default};
    border-radius: 5px;
    outline: none;
    padding: 8px;
  }
`

const CleanTextArea = ({ className, inputRef, label, defaultValue, value, onChange, ...rest }) => (
  <ThemeProvider theme={theme}>
    <CleanTextAreaWrapper className={className}>
      {/** biome-ignore lint/a11y/noLabelWithoutControl: TODO */}
      {label && <label>{label}</label>}
      <textarea ref={inputRef} onChange={onChange} className="clean-text-area" {...rest}>
        {value}
      </textarea>
    </CleanTextAreaWrapper>
  </ThemeProvider>
)

CleanTextArea.defaultProps = {
  onChange: f => f,
}

export default CleanTextArea
